import React from "react";

export default function VisionSection() {
  return (
    <section className="about-vision">
      <div className="about-vision__inner">
        <h2>
          Enterprises don&apos;t lack information – they lack clarity, compliance, and connected
          intelligence.
        </h2>
        <p>
          Highwatch was built to bridge that gap – securely, transparently, and at scale.
        </p>
      </div>
    </section>
  );
}
